import { observer } from 'mobx-react-lite'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'
import { CONTACTS_METRICS_CONFIG } from 'entities/Analytics/lib/constants'
import { type ContactsChartDataStore } from 'pages/analytics/pages/contacts/ui/Chart/store/contactsChartDataStore'
import styles from '../styles.module.scss'

interface ContactsBarChartProps {
  chartDataStore: ContactsChartDataStore
  hiddenMetrics?: Set<string>
}

export const ContactsBarChart = observer(
  ({ chartDataStore, hiddenMetrics = new Set() }: ContactsBarChartProps) => {
    const { rechartsData } = chartDataStore

    return (
      <div className={styles.chartContainer}>
        <ResponsiveContainer width='100%' height={300}>
          <BarChart data={rechartsData} margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
            <CartesianGrid vertical horizontal={false} strokeDasharray={5} />
            <XAxis dataKey='name' interval='preserveStartEnd' minTickGap={1} />
            <YAxis />
            <Tooltip cursor={false} />
            {Object.entries(CONTACTS_METRICS_CONFIG).map(([key, config]) => {
              if (hiddenMetrics.has(key)) return null

              return (
                <Bar key={key} dataKey={key} fill={config.color} name={config.name} radius={6} />
              )
            })}
          </BarChart>
        </ResponsiveContainer>
      </div>
    )
  }
)
